import React, { Component } from 'react';
import { PeriodContainer } from './PeriodContainer';
import { Helmet } from 'react-helmet';
import { Graph } from './Graph';

export class Home extends Component {
  static displayName = Home.name;

    constructor(props) {
        super(props);
        this.state = {
            selectYear: new Date().getFullYear()
        };
    }

    handleChange(event) {
        this.setState({
            selectYear: event.target.value
        });
    }

    setOptions() {
        var today = new Date();
        var currentYear = today.getFullYear();
        var currentMonth = today.getMonth() + 1;
        var currentDay = today.getDate();
        var startYear = 2020;
        var options = new Array();

        for (var i = startYear; i <= currentYear; i++) {
            var option = i.toString();

            if (currentYear == i) {
                // don't show the new year, until the 15th of february
                if ((currentMonth > 0 && currentDay > 15) || currentMonth > 1) {
                    console.log("this to show");
                    options.push(option);
                }
            } else {
                options.push(option);
            }
        }

        return options;
    }

    render() {
        const options = this.setOptions();

        return (
            <div>
                <Helmet>
                    <meta charSet='utf-8' />
                    <title>FAK Ledighedsstatistik</title>
                </Helmet>
                <h1>Ledighedsstatistik</h1>
                <div id="stat-wrapper">
                    <div id="stat-explain">
                        <p>
                            <b>Fuldtidsledige:</b> Det samlede antal ledighedstimer svarende til fuldtidsstillinger (160,33 timer pr. måned).<br/>
                            <b>Berørte:</b> Antallet af medlemmer, som har været ledige i perioden.<br/>
                            <b>Fuldtids ledige:</b> Antallet af medlemmer, som har været fuldtidsledige set i forhold til det samlede antal medlemmer.<br/>
                            <b>Berørtes ledighed:</b> Antallet af medlemmer berørt af ledighed set i forhold til det samlede antal medlemmer.
                            <br /><br />
                            <b>Opgørelsestidspunkt:</b> Statistikken opgøres den 15. i den efterfølgende måned.
                            <br /><br />
                            Fra februar 2021 opgøres tallene for alle fem forbund, ud fra det samlede antal medlemmer i de enkelte forbund.
                        </p>
                    </div>
                    {/*<div className='graph-container'>*/}
                    {/*    <p>Fuldtidsledige</p>*/}
                    {/*    <Graph def={[25, 30, 35, 40, 15]} mfd={[24, 15, 40, 20, 21]} />*/}
                    {/*</div>*/}
                </div>
                <p className='select-year-headline'>Vælg år</p>
                <div className='select-year-container'>
                    <select className='select-year' value={this.state.selectYear} onChange={(e) => this.handleChange(e)} >
                        {options.map((option, index) => {
                            return <option value={option} key={index}>{option}</option>
                        })}
                    </select>
                </div>
                {(this.state.selectYear !== '') ? <PeriodContainer periodyear={this.state.selectYear} /> : ''}
            </div>
        );
    }
}
